import styles from './glossary-item.module.css'

export const GlossaryItem = ({title, description}) => {
    return (
        <div className={styles.item}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
        </div>
    );
};